var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignRight03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0022 21L21.0022 17.9986M21.0022 17.9986V10.2386M21.0022 17.9986L4.61806 17.9986C4.0517 17.9986 3.7685 17.9986 3.55218 17.8896C3.36189 17.7937 3.20718 17.6407 3.11023 17.4526C3 17.2387 3 16.9586 3 16.3986L3 15.3559C3 14.7959 3 14.5159 3.11023 14.302C3.20718 14.1138 3.36189 13.9608 3.55218 13.8649C3.7685 13.7559 4.05169 13.7559 4.61807 13.7559L21.0022 13.7559M21.0022 10.2386V5.99594M21.0022 10.2386L8.46323 10.2386C7.89686 10.2386 7.61366 10.2386 7.39734 10.1296C7.20705 10.0337 7.05234 9.88074 6.95539 9.69257C6.84516 9.47866 6.84516 9.19864 6.84516 8.63858L6.84516 7.59594C6.84516 7.03589 6.84516 6.75586 6.95539 6.54195C7.05234 6.35379 7.20705 6.20081 7.39734 6.10494C7.61366 5.99594 7.89685 5.99594 8.46323 5.99594L21.0022 5.99594M21.0022 5.99594V3",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight03);
export default __webpack_public_path__ + "static/media/align-right-03.4255a6f69ce717dd740a0ef71ff5278e.svg";
export { ForwardRef as ReactComponent };